'use strict';
define([
    'angular',
    'modules/seospider/exam/analysis/detail/keywords/keywords.controller'
],function(angular,SinglePageKeywordsCtrl){
    var app=angular.module('app.seospider.exam.analysis.detail.keywords', []);
    app.controller('SinglePageKeywordsCtrl',SinglePageKeywordsCtrl);
    return app;
});